import {useStoreService} from '../../service/store/index'
import { IStoreByUser } from '../../service/store/interfaces/IStoreByUser';

const useGetUserRelated = () => {
  const {getAllUsersRelated, updateUsersByStore} = useStoreService()

  const getUsersRelated = async (id: number) => {
    await getAllUsersRelated(id).then((resp) => {
      return resp
    }).catch((error) => {
      return error
    });;
  };

  const updateUsersRelated = async (data: IStoreByUser) => {
    await updateUsersByStore(data).then((resp) => {
      return resp
    }).catch((error) => {
      return error
    });;
  };
  return {
    getUsersRelated,
    updateUsersRelated
  };
};

export default useGetUserRelated;
